<template>
  <div :title="t('headerTools.language')" class="common-header-language" v-clickoutside="hidePanel">
    <div
      :class="[
        'language-button',
        { active: visiable }
      ]"
      @click="visiable = !visiable"
    >
      <icon class="language" type="language-switch" size="22"></icon>
    </div>
    <div class="language-panel" v-show="visiable">
      <ul class="language-list">
        <li
          v-for="item of list"
          :key="item.value"
          :title = "item.name"
          @click="switchLanguage(item.value)"
        >
          {{item.name}}
        </li>
      </ul>
    </div>
  </div>
  </template>

  <script>
  import Cookie from 'js-cookie';
  import Icon from '../../components/icon';
  import clickoutside from '../../directives/clickoutside';
  import i18nHandle from '../../locales';

  const LOCALE_KEY = '_t_language';
  const LANGUAGE_LIST = [
    {
      name: '中文简体',
      value: 'zh-CN',
    },
    {
      name: '中文繁體',
      value: 'zh-TW',
    },
    {
      name: 'English',
      value: 'en',
    },
  ];

  export default {
    components: {
      Icon,
    },
    directives: {
      clickoutside,
    },
    data() {
      return {
        visiable: false,
        list: LANGUAGE_LIST,
      };
    },
    mounted() {
      const isTW = window.location.host.includes('okki.com');
      const isJP = window.location.host.includes('okki.io');

      const language = Cookie.get(LOCALE_KEY);
      if (language === undefined && isTW) {
        this.switchLanguage('zh-TW');
      }
      if (language === undefined && isJP) {
        this.switchLanguage('en');
      }
    },
    methods: {
      switchLanguage(language) {
        Cookie.remove(LOCALE_KEY);
        const isTW = window.location.host.includes('okki.com');
        const isJP = window.location.host.includes('okki.io');
        const domain = isTW ? '.okki.com' : '.xiaoman.cn';
        const domain2 = isJP ? '.okki.io' : domain;
        Cookie.set(LOCALE_KEY, language, {
          domain: domain2,
          expires: 365 * 10,
        });
        this.$emit('switch', language);
      },

      hidePanel() {
        this.visiable = false;
      },

      t: i18nHandle.t,
    },
  };
  </script>

  <style lang="scss">
  @import '../../assets/styles/_variable';
  $col: 2;
  $width: 100px;
  $margin: -1px;

  .common-header-language {
    position: relative;

    .language-button {
      cursor: pointer;

      &.active,
      &:hover {
        .language {
          color: #2997f5;
        }
      }
      span {
        margin-right: 8px;
        color: inherit;
        font-size: 14px;
      }

      .language {
        color: #909090;
      }
    }
    .language-panel {
      position: absolute;
      top: calc(#{$layoutHeaderHeight} + -20px);
      right: -20px;
      border-radius: 4px;
      background: #fff;
      box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.26);

      &::before {
        position: absolute;
        top: -6px;
        right: 26px;
        width: 12px;
        height: 12px;
        background-color: #fff;
        box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.26);
        content: '';
        transform: rotate(45deg);
      }

      &::after {
        position: absolute;
        top: 0;
        right: 20px;
        width: 25px;
        height: 12px;
        background-color: #fff;
        content: '';
      }
    }

    .language-list {
      position: relative;
      z-index: 2;
      > li {
        padding: 10px 30px;
        cursor: pointer;
        border-bottom: 1px solid #eee;
        word-break: keep-all;

        &:hover {
          color: #0884f3;
          background: rgba(8, 132, 243, 0.07);
        }
      }
    }
  }
  </style>
